/**
 * @generated SignedSource<<3142451f2c0af0e189e94232ab0b0154>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type useCurrentClubHasVisibleLessons_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly departments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly anyFacilityLessonsEnabled: boolean;
              readonly facilities: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly isLessonsEnabled: boolean;
                    readonly privateLessonsPermissionSet: {
                      readonly patronAccess: LessonAccess | null | undefined;
                    } | null | undefined;
                    readonly publicLessonsPermissionSet: {
                      readonly patronAccess: LessonAccess | null | undefined;
                    } | null | undefined;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useIsCurrentUserPublic_session">;
  readonly " $fragmentType": "useCurrentClubHasVisibleLessons_session";
};
export type useCurrentClubHasVisibleLessons_session$key = {
  readonly " $data"?: useCurrentClubHasVisibleLessons_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentClubHasVisibleLessons_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentClubHasVisibleLessons_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsCurrentUserPublic_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DepartmentConnection",
                  "kind": "LinkedField",
                  "name": "departments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DepartmentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Department",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "anyFacilityLessonsEnabled",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FacilityConnection",
                              "kind": "LinkedField",
                              "name": "facilities",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FacilityEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Facility",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "isLessonsEnabled",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "PublicLessonsPermissionSet",
                                          "kind": "LinkedField",
                                          "name": "publicLessonsPermissionSet",
                                          "plural": false,
                                          "selections": (v0/*: any*/),
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "PrivateLessonsPermissionSet",
                                          "kind": "LinkedField",
                                          "name": "privateLessonsPermissionSet",
                                          "plural": false,
                                          "selections": (v0/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "31c15cc22615eb31b0a0bc53ee4c035f";

export default node;
